import { render } from "./BrandsPopupFiltersModal.vue?vue&type=template&id=057e3a5c&scoped=true"
import script from "./BrandsPopupFiltersModal.vue?vue&type=script&lang=js"
export * from "./BrandsPopupFiltersModal.vue?vue&type=script&lang=js"

import "./BrandsPopupFiltersModal.vue?vue&type=style&index=0&id=057e3a5c&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057e3a5c"],['__file',"src/components/BrandsPopupFiltersModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "057e3a5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('057e3a5c', __exports__)) {
    console.log('reload')
    api.reload('057e3a5c', __exports__)
  }
  
  module.hot.accept("./BrandsPopupFiltersModal.vue?vue&type=template&id=057e3a5c&scoped=true", () => {
    console.log('re-render')
    api.rerender('057e3a5c', render)
  })

}


export default __exports__